export const parseTimeToSeconds = (time) => {
  if (!time || typeof time !== 'string') return Number.MAX_VALUE;
  const cleanTime = time.replace(/[YL]$/, ''); // Remove Y or L
  try {
    if (cleanTime.includes(':')) {
      const [minutes, seconds] = cleanTime.split(':').map(Number);
      return minutes * 60 + seconds;
    }
    return parseFloat(cleanTime);
  } catch (err) {
    console.error(`Error parsing time '${time}':`, err);
    return Number.MAX_VALUE;
  }
};

export const formatTime = (time) => {
  if (!time || typeof time !== 'string') return 'N/A';
  return time;
};